import { useCallback, useEffect, useRef, useState, Fragment } from 'react';
import { Breadcrumb, PopUpModal, SuccessPopupModal, TextInput, Title } from '../../Components/Atoms';
import { useNavigate, useParams } from 'react-router-dom';
import { deleteVehicleFromInventory, getVehiclesInfo } from '../../APIs';
import PATH from '../../Routes/paths';
import './style.css'
import { CHARGING_TYP_REV_MAP } from '../../Library/constants';
import { Button, useToast } from '@chakra-ui/react';
import { DeleteIcon, PenIcon } from '../../Assets/images/svgs';

const FIELD_TYPE = {
  TEXT: 1,
  AUTOCOMPLETE: 2,
};

const VehicleDetail = () => {
  const { vId } = useParams();
  const [formFields, setFormFields] = useState([]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [confirmDeleteVehicle, setConfirmDeleteVehicle] = useState({});
  const Navigate = useNavigate();
  const vehicleDetail = useRef({});
  const Toast = useToast();

  const getFormFields = useCallback((formData) => {
    if (!formData) return [];
    
    const formFields = [
      {
        type: FIELD_TYPE.TEXT,
        label: "Registration Number",
        name: "reg",
        value: formData.reg
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Chassis Number",
        name: "chNum",
        value: formData.chNum
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Vehicle Model",
        name: "mo",
        value: formData.mo
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Vehicle Color",
        name: "clrNm",
        value: formData.clrNm
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Charger Type",
        name: "cTyp",
        value: CHARGING_TYP_REV_MAP[formData.cTyp]
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Motor Number",
        name: "mtrNum",
        value: formData.mtrNum
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Battery Number",
        name: "bId",
        value: formData.bId
      },
      {
        type: FIELD_TYPE.TEXT,
        label: "Ajjas IMEI",
        name: "imei",
        value: formData.imei
      }
    ];
    return formFields;
  }, []);

  useEffect(() => {
    const fetchVehicleDetail = (vId) => {
      getVehiclesInfo(null, vId, (err, resp) => {
        if (err) console.error("VehicleDetail : Error while fetching all vehicles", err);
        else {
          vehicleDetail.current = resp[0] || {};
          setFormFields(getFormFields(resp[0]));
        }
      })
    }

    fetchVehicleDetail(vId);
  }, [getFormFields, vId])

  const DeleteVehicle = (vId) => {
    deleteVehicleFromInventory(+vId, (err) => {
      if (err) {
        console.error("VehicleDetail : Error while delete vehicle", err);
        setConfirmDeleteVehicle({});
        Toast({ isClosable: true, description: "Failed to delete vehicle", position: "bottom", status: "error", variant: "solid" });
      }
      else {
        setShowSuccessModal(true);
      }
    })
  }

  const deleteVehicle = () => {
    setConfirmDeleteVehicle({
      open: true,
      modalMsg: "Removing vehicle will also unmap the Ajjas device. Are you sure you want to remove vehicle from inventory?",
      confirmBtn: "Remove",
      closeBtn: "Cancel",
      onConfirm: () => DeleteVehicle(vId),
      onModalClose: () => setConfirmDeleteVehicle({}),
    });
  }

  const editVehicle = () => {
    Navigate(PATH.ADDVEHICLE+`?vid=${vId}`, {state: { vehicleDetail: vehicleDetail.current }, replace: true})
  }

  const breadcrumbPaths = [
    { idx: 1, name: "Inventory Management", link: PATH.INVENTORY },
    { idx: 1, name: "Vehicles", link: PATH.VEHICLES },
    { idx: 1, name: vehicleDetail.current.reg, link: "", isCurrentPage: true },
  ]

  return (
    <div className='panel-main vehicle-detail-container'>
      <PopUpModal {...confirmDeleteVehicle} />
      {showSuccessModal &&
        <SuccessPopupModal open={true} modalMsg={"Vehicle removed successfully"} closeBtn={"Okay"} modalSize={"lg"} onModalClose={() => { setShowSuccessModal(false); Navigate(PATH.VEHICLES)}} />}

      <div>
        <Breadcrumb paths={breadcrumbPaths} />
      </div>

      <div className="vehicle-detail-main">
        <div className='vehicle-detail-header'>
          <Title>Vehicle Details</Title>
          {
            vehicleDetail.current.reg ? <div className='vehicle-detail-btn-wrapper'>
              <Button leftIcon={<PenIcon />} className='edit-vehicle' iconSpacing={1} variant={"outline"} onClick={editVehicle}>Edit</Button>
              <Button leftIcon={<DeleteIcon />} className='delete-vehicle' iconSpacing={0} variant={"outline"} onClick={deleteVehicle}/>
            </div>: null
          }
        </div>
        <form className='vehicle-detail-form'>
          {
            formFields.map((formField, idx) => {
              return <Fragment key={idx}>
                {
                  formField.type === FIELD_TYPE.TEXT && (
                    <TextInput
                      inputName={formField.name || ""}
                      placeholder={formField.placeholder}
                      className="vehicle-detail-text-field"
                      label={formField.label}
                      labelClassName="vehicle-detail-text-field-label"
                      value={formField.value}
                      readonly={true}
                    />
                  )
                }
              </Fragment>
            })
          }
        </form>
      </div>
    </div>
  )
}

export default VehicleDetail;